<template>
  <div class="h-[100vh] bg-[#1D2229]">
    <NuxtLayout>
      <NuxtPage/>
    </NuxtLayout>
  </div>
</template>


